
// Skills every character is automatically granted for free (0 SP) on load.
// Ids: Identify (4), Meditate (5), Tap Reserves (14).
export const AUTO_GRANTED_SKILL_IDS = [4, 5, 14];

// Skills shown under the "Innate Skills" category. Spell Strike (13) lives here
// too, but it is NOT auto-granted — it's an explicit build choice the player
// adds/removes themselves (and that choice persists).
export const INNATE_CATEGORY_SKILL_IDS = [4, 5, 14, 13];

// Granted skills the player can never remove.
export const LOCKED_SKILL_IDS = [4, 5, 14];

// True when a skill can't be removed/changed: the locked innate skills, plus the
// auto-added transform/racial abilities (skillset 8, tier 0 — same set
// addStaticSkills grants below).
export function isLockedSkill(baseSkill) {
    if (!baseSkill) return false;
    if (LOCKED_SKILL_IDS.includes(baseSkill.skillId)) return true;
    return Number(baseSkill.skillset) === 8 && Number(baseSkill.tier) === 0;
}

export function getSkillId (skills, skillName) {
    return getSkill(skills, skillName)?.skillId;
}

export function getSkill (skills, skillName) {
    return skills.find(s => s.name.toLowerCase() === skillName.toLowerCase());
}

export function addStaticSkills (existingSkills = [], availableSkills = []) {
    const staticSkills = availableSkills.filter(s => s.skillset === 8 && s.tier === 0);

    // Always-granted skills, looked up from the catalog so we carry their name/skillset.
    const autoGranted = availableSkills.filter(s => AUTO_GRANTED_SKILL_IDS.includes(s.skillId));

    const purchasedSkillIds = existingSkills.map(s => s.skillId);
    const skillsToAdd = [...staticSkills, ...autoGranted].reduce((acc, skill) => {
        if (!purchasedSkillIds.includes(skill.skillId) && !acc.some(a => a.skillId === skill.skillId)) {
            acc.push({
                skillId: skill.skillId,
                ranks: 1,
                name: skill.name,
                skillset: Number(skill.skillset) || 0,
                prereqs: [],
            });
        }
        return acc;
    }, []);

    return [...existingSkills, ...skillsToAdd];
}

